<template>
    <div class="table-responsive border">
      <table class="table table-hover text-center" id="dataTable" width="100%"
        cellspacing="0">
        <thead>
          <tr>
            <th>Title</th>
            <th>Due Date</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody v-show="isLoader">
            <tr id="table_row">
              <td colspan="16">
                <b-skeleton-wrapper>
                  <b-skeleton height="40px"></b-skeleton>
                  <b-skeleton height="40px"></b-skeleton>
                  <b-skeleton height="40px"></b-skeleton>
                </b-skeleton-wrapper>
              </td>
            </tr>
          </tbody>
        <tbody v-show="!isLoader">
        <tr v-for="contract in contracts" :key="contract.id">
            <td>{{ contract['title'] }}</td>
            <td v-if="contract['due_date']">{{ contract['due_date'] | formatDate }}</td>
            <td v-else>{{"---"}}</td>
            <td>{{ contract['status'] == 1 ? "Active" : "Inactive" }}</td>
            <td>{{ contract['first_name']+' '+ contract['last_name']}}</td>
            <td>
              <div>
              <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                  <span class="fas fa-ellipsis-v"></span>
                </a>
              <ul class="dropdown-menu">
                <template>
                  <router-link class="dropdown-item" :to="'/customer-contracts/update-contract/' + contract['id']">Edit</router-link>
                  <!-- <a class="dropdown-item" @click="deleteContract(contract['id'])">Delete</a> -->
                </template>
              </ul>
            </div>
            </td>
        </tr>
        <tr v-if="contracts.length<=0" class="text-center"><td colspan="5">No Record Found</td></tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  Vue.filter("formatDate", function (value) {
    if ( value != null) {
      return moment(String(value)).format("MMM DD, Y");
    }
  });
    export default {
      data: function (){
        return {
          isLoader: true,
        };
      },
      props: ['contracts'],

      mounted:function(){
        setTimeout(() => {
          this.isLoader = false;
        },200);
      },
      methods: {
        deleteContract(id) {
          this.$store.dispatch("message/update", {
            body: "Are you sure you want to delete this Comment?",
            class: "danger",
            confirm: true,
          });

          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(id);
            this.$store.dispatch("message/close");
          });
        },
        delete(id){ 
          this.$store.dispatch("termsandconditions/deleteContract",id)
          .then((response) => {
            // send successful message
            
            this.$toast.success(response.data.message);
             this.$store.dispatch("termsandconditions/getAllContracts");
          })
          .catch((error) => {
            // send error message
            this.$toast.error(response.data.message);
          });
        }
      }
    }
  </script>
<style>
.dropdown-menu > .dropdown-item:active {
 background-color: #48a6a6 !important;
}
</style>